import { categories, navLinks, siteName } from "@/mocks/campus";

const contactEmail = "hello@guatian.example.com";

export default function Footer() {
  return (
    <footer id="contact" className="border-t border-background-200 bg-background-100 scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.3fr_0.9fr_0.9fr_1fr]">
          {/* 品牌 */}
          <div className="flex flex-col items-start gap-4">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-600 font-heading text-xl text-background-50">瓜</span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg text-foreground-950">{siteName}</span>
                <span className="mt-1 text-[10px] font-medium tracking-[0.2em] text-primary-600">CAMPUS GOSSIP PICK</span>
              </span>
            </a>
            <p className="max-w-xs text-sm leading-relaxed text-foreground-600">
              校园吃瓜热门话题榜与头条焦点事件全收录，一页看遍今日校园热搜。轻松围观，理性表达，吃瓜路上不掉队。
            </p>
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-secondary-800 whitespace-nowrap"><i className="ri-shield-check-line" /> 隐私优先</span>
              <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-secondary-800 whitespace-nowrap"><i className="ri-verified-badge-line" /> 内容需核实</span>
            </div>
          </div>

          {/* 快速直达 */}
          <nav className="flex flex-col gap-3" aria-label="页脚导航">
            <h3 className="font-heading text-base text-foreground-950">快速直达</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navLinks.map((l) => (
                <li key={l.anchor}>
                  <a href={`#${l.anchor}`} className="inline-flex items-center gap-1 text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    <i className="ri-arrow-right-s-line text-primary-400" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 热门分类 */}
          <div className="flex flex-col gap-3">
            <h3 className="font-heading text-base text-foreground-950">热门分类</h3>
            <div className="flex flex-wrap gap-2">
              {categories.map((c) => (
                <span key={c.slug} className="inline-flex items-center gap-1 rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 ring-1 ring-background-300 whitespace-nowrap">
                  <i className={`${c.icon} text-primary-500`} />
                  {c.name}
                </span>
              ))}
            </div>
          </div>

          {/* 联系方式 */}
          <div className="flex flex-col gap-3">
            <h3 className="font-heading text-base text-foreground-950">投稿与联系</h3>
            <p className="text-sm leading-relaxed text-foreground-600">把身边真实、有趣且不涉及隐私的校园瞬间分享给我们。</p>
            <a href={`mailto:${contactEmail}`} className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap w-fit">
              <i className="ri-mail-send-line" />
              {contactEmail}
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-200/50">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>本站内容整理自公开讨论与用户投稿，仅供校园生活交流。请理性看待热点、尊重他人隐私，不传播谣言与未经核实的信息。</p>
          <p className="flex items-center gap-2 whitespace-nowrap">
            <span>© {new Date().getFullYear()} {siteName} · 校园吃瓜热门话题榜</span>
            <a href="#top" aria-label="返回顶部" className="flex h-7 w-7 items-center justify-center rounded-full bg-background-50 text-foreground-500 ring-1 ring-background-300 transition-colors hover:bg-primary-500 hover:text-background-50">
              <i className="ri-arrow-up-line text-sm" />
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}